import { render, staticRenderFns } from "./RoundButtonNoRedirect.vue?vue&type=template&id=61d0f4f6&"
import script from "./RoundButtonNoRedirect.vue?vue&type=script&lang=js&"
export * from "./RoundButtonNoRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports